module.exports = __webpack_public_path__ + "img/svg4.7573219f.svg";